import { ThemeProvider } from '@emotion/react'
import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useHeaderButtons } from '../../sharedComponents/src/Contexts/HeaderButtonsContext'
import { useStoreActions, useStoreState } from '../../store/hooks'
import theme from '../../theme/theme-v2'
import { ChallengeCompletePopup } from './ChallengeCompletePopup'
import { RewardButton } from './RewardButton'

export const RewardService = () => {
    const userData = useStoreState((state) => state.userData)
    const getRewards = useStoreActions((state) => state.rewardsService.getRewards)
    const { registerButton, unregisterButton } = useHeaderButtons()
    const location = useLocation()

    useEffect(() => {
        userData.userData?.id && getRewards()
    }, [userData.userData?.id])

    const isProfilePage = location.pathname.includes('/profile')

    useEffect(() => {
        !isProfilePage && registerButton('rewardsNavigation', <RewardButton />)
        return () => {
            unregisterButton('rewardsNavigation')
        }
    }, [isProfilePage])

    return (
        <ThemeProvider theme={theme}>
            <ChallengeCompletePopup />
        </ThemeProvider>
    )
}
